var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdvallyTag",attrs:{"id":("HP-MPU" + _vm.list_index + "-mobile"),"data-slot":("mrqe.com/HP-MPU" + _vm.list_index + "-mobile"),"data-size":"300x250"}})}
var staticRenderFns = []

export { render, staticRenderFns }